import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular,
    CustomLabelSmallBold, CustomLabelSmallMedium,
    CustomLabelSmallRegular
} from "../common/CustomLabel";
import Paper from "@mui/material/Paper/Paper";
// import DEVELOPER_LOGO from "../../assets/images/developer.png";
// import CIRCLE_BLUE from "../../assets/images/check-circle.png";
import LAPTOP_DEV_MODE from "../../assets/images/laptop-dev-mode.png";
// import PROJECT from "../../assets/images/project.png";
import MAIL_OUT from "../../assets/images/mail-out.png";
// import PARTNER from "../../assets/images/partner.png";
import BOX_ICON from "../../assets/images/3d-center-box.png";
import React, { useState, useEffect, useRef } from 'react';
// import FULL_PROJECT_DEVELOPMENT from "../../assets/gif/FullProjectDevelopement.gif";
// import ON_DEMAND_DEVELOPERS from "../../assets/gif/OnDemandDeveloper.gif";
// import PROJECT_BI_EQUITY from "../../assets/gif/ProjectByEquity.gif";
import FULL_PROJECT_DEVELOPMENT from "../../assets/images/FullProjectDevelopement.png";
import ON_DEMAND_DEVELOPERS from "../../assets/images/OnDemandDeveloper.png";
import PROJECT_BI_EQUITY from "../../assets/images/ProjectByEquity.png";

import Box from "@mui/material/Box/Box";
// import ARROW_UP from "../../assets/images/arrow-up-right.png";
import {useNavigate} from "react-router-dom"
import NorthEastIcon from '@mui/icons-material/NorthEast';
import CheckIcon from '@mui/icons-material/Check';

const OurServices = ({serviceRef, setShowOnDemandDevelopers, setShowWhatService, setShowFullProject, setShowProjectByEquity}) => {
    const [visibleGifs, setVisibleGifs] = useState({
        first: false,
        second: false,
        third: false
    });
    const [isInView, setIsInView] = useState(false);
    const animationRef = useRef(null);
    const navigate = useNavigate();
    
    // Common styles that can be reused
    const commonPaperStyles = {
                            width: "100%", 
                            background: 'white', // Base white background
                            borderRadius: 10,
                            transition: 'all 0.3s ease-in-out',
                            cursor: 'pointer',
                            flexDirection: 'column',
                            height: '100%',
                            position: 'relative',
                            '&:hover': {
                                transform: 'translateY(-5px)',
                                border: '1px solid #5E17EB',
                                // backgroundImage: 'linear-gradient(to top,rgb(240, 230, 255), transparent 50%), linear-gradient(to top, white 50%, white 100%)', // Gradient in bottom 20% then white

                                // boxShadow: '0 4px 20px rgba(94, 23, 235, 0.1)',
                                // '&::after': {
                                //     content: '""',
                                //     position: 'absolute',
                                //     bottom: 0,
                                //     left: 0,
                                //     right: 0,
                                //     height: '200px',
                                //     background: 'linear-gradient(to top, #5E17EB, transparent)',
                                //     borderBottomLeftRadius: 40,
                                //     borderBottomRightRadius: 40,
                                //     opacity: 0.15,
                                // },
                                '& .service-image': { filter: 'grayscale(0%)' },
                                
                                // '& .tags-container': {
                                //     opacity: 1,
                                // },
                            },
                            '&:hover': {
                                '& .tags-container': {
                                    opacity: { md: 1},
                                },
                            },
                            '& .MuiGrid-item:nth-of-type(2) .MuiTypography-root': {
                                filter: 'grayscale(100%)',
                                transition: 'filter 0.3s ease-in-out',
                            },
                            '&:hover .MuiGrid-item:nth-of-type(2) .MuiTypography-root': {
                                filter: 'grayscale(0%)',
                            },
                            '& .MuiGrid-item img': {
                                // filter: 'grayscale(100%)',
                                transition: 'filter 0.3s ease-in-out',
                            },
                            '&:hover .MuiGrid-item img': {
                                filter: 'grayscale(0%)',
                            }
    };

    const commonButtonStyles = {
                                    border: "1.5px solid #F5F5F5",
                                    borderRadius: "20px",
                                    padding: {xs: "10px 15px", md: "15px 25px"},
                                    background: "#5E17EB", 
                                    marginTop: "20px", 
                                    cursor: "pointer",
                                    transition: 'transform 0.2s ease',
                                    '&:hover': {
                                        transform: 'scale(1.05)'
                                    }
    };

    // Service card data
    const serviceCards = [
        {
            image: ON_DEMAND_DEVELOPERS,
            title: "On-Demand Developers",
            description: "No long-term commitments, no hiring headaches - just skilled developers ready to jump in.",
            buttonIcon: LAPTOP_DEV_MODE,
            buttonText: "Hire On Demand Developer",
            click: setShowOnDemandDevelopers,
            gifIndex: 'first',
            tags: ['Flexible team scaling', 'Hassle-free hiring', 'Top-tier expertise']
        },
        {
            image: FULL_PROJECT_DEVELOPMENT,
            title: "Full Project Development",
            description: "We handle everything - design, development, and deployment—so you can focus on growth.",
            buttonIcon: MAIL_OUT,
            buttonText: "Request a Consultation",
            click: setShowFullProject,
            gifIndex: 'second',
            tags: ['End-to-end solutions', 'Tailored deliverables', 'Transparent process']
        },
        {
            image: PROJECT_BI_EQUITY,
            title: "Project By Equity",
            description: "Digital Solutions at Zero upfront costs - success is shared, and expertise is guaranteed.",
            buttonIcon: BOX_ICON,
            buttonText: "Discuss Your Project",
            click: setShowProjectByEquity,
            gifIndex: 'third',
            tags: ['Shared risk & rewards', 'No upfront costs', 'Access to experts']
        }
    ];

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                setIsInView(entry.isIntersecting);
            },
            { threshold: 0.2 } // Trigger when 20% of the section is visible
        );

        if (serviceRef?.current) {
            observer.observe(serviceRef.current);
        }

        return () => {
            if (serviceRef?.current) {
                observer.unobserve(serviceRef.current);
            }
        };
    }, [serviceRef]);

    useEffect(() => {
        const startAnimation = () => {
            setVisibleGifs({ first: false, second: false, third: false });
            
            const delays = [200, 1200, 2200];
            const gifs = ['first', 'second', 'third'];
            
            gifs.forEach((gif, index) => {
                setTimeout(() => {
                    setVisibleGifs(prev => ({ ...prev, [gif]: true }));
                }, delays[index]);
            });
        };

        // Only start animation when section is in view and hasn't played yet
        if (isInView) {
            startAnimation();
        } else {
            // Reset when section is not in view
            setVisibleGifs({ first: false, second: false, third: false });
        }

        return () => {
            if (animationRef.current) {
                clearTimeout(animationRef.current);
            }
        };
    }, [isInView]); // Only runs when isInView changes

    const ServiceCard = ({ card, index }) => (
        <Grid item xs={12} md={5.8} lg={3.8} sx={{ 
            marginTop: {
                xs: "20px",
                md: index === 0 ? "0px" : "20px",
                lg: "0px",
            },
            borderRadius: 10,
            border: "0.5px solid #DDDDDD",
            // height: "100%"
        }}>
            <Paper sx={{
                ...commonPaperStyles,
                transition: 'background-image 0.3s ease-in-out',
                '&:hover': {
                    border: "0.5px solid #5E17EB",
                    backgroundImage: 'linear-gradient(to top,rgb(240, 230, 255), transparent 20%), linear-gradient(to top, white 20%, white 100%)',
                    '& .tags-container': {
                        opacity: 1
                    }
                },
            }}>
                <Grid container alignItems="center" direction="column" sx={{padding: {xs: "20px", md: "20px 40px"}}}>
                    <Grid item xs={12} sx={{width: "75%", position: 'relative'}}>
                        <Box
                            component="img"
                            className="service-image"
                            src={card.image}
                            alt={card.title}
                            sx={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'contain',
                                display: 'block',
                                // opacity: visibleGifs[card.gifIndex] ? 1 : 0,
                                // filter: 'grayscale(100%)',
                                transition: 'all 0.5s ease-in-out',
                            }}
                        />
                        <Box className="tags-container" sx={{
                            position: 'absolute',
                            top: '0px',
                            left: 0,
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                            alignItems: 'flex-start',
                            opacity: {xs: 1, md: 0},
                            transition: 'opacity 0.3s ease-in-out',
                            zIndex: 11,
                        }}>
                            {card.tags.map((tag, i) => (
                                <Box key={i} sx={{
                                    backgroundColor: 'transparent',
                                    border: '1px solid #5E17EB',
                                    backdropFilter: 'blur(10px)',
                                    color: '#5E17EB',
                                    padding: {xs: '10px 14px', md: '18px 24px'},
                                    borderRadius: 50,
                                    fontSize: {xs: '10px', md: '18px'},
                                    whiteSpace: 'nowrap',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '16px',
                                    alignSelf: i === 0 ? 'flex-start' : i === 1 ? 'flex-end' : 'flex-start',
                                    marginLeft: {xs: (i === 0 || i === 2) ? '-24%' : 'auto', md: (i === 0 || i === 2) ? '-30%' : 'auto'},
                                    marginRight: {xs: i === 1 ? '-24%' : 'auto', md: i === 1 ? '-30%' : 'auto'},
                                    marginTop: {xs: i === 1 ? '20%' : '10%', md: i === 1 ? '20%' : '10%'},
                                    transform: 'translateY(0)',
                                    transition: 'transform 0.3s ease-in-out',
                                }}>
                                    <CheckIcon sx={{ color: "#5E17EB", fontSize: {xs: '10px', md: '18px'} }} />
                                    {tag}
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item sx={{marginTop: {xs: "10px", md: "20px"}}}>
                        <CustomLabelSmallBold text={card.title} color="#5E17EB" fontWeight={700}/>
                    </Grid>
                    <Grid item style={{marginTop: "10px"}}>
                        <CustomLabelSmallRegular text={card.description} color="#A3A3A3"/>
                    </Grid>
                    <Grid item container sx={{...commonButtonStyles, zIndex: 5}}
                                onClick={(e) => {
                                    e.stopPropagation();
                              card.click(true);
                                }}
                          alignItems="center" justifyContent="center">
                                <Grid item>
                            <img src={card.buttonIcon} alt={card.buttonText}/>
                                </Grid>
                                <Grid item style={{marginLeft: "10px"}}>
                            <CustomLabelSmallMedium text={card.buttonText} color="white"/>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    );

    return (
        <Grid container sx={{
            marginTop: {xs: "40px", md: "60px"},
            background: "#FAF7FF",
            px : { xs: 1, md: 5},
            paddingBottom: {xs: "30px", md: "50px"}
        }} justifyContent="center">
              <div ref={serviceRef} tabIndex={0}/>
            {/* Header section */}
            <Grid item container justifyContent="center" sx={{marginTop: {xs: "30px", md: "50px"}, textAlign: "center"}}>
                <CustomLabelMediumBold text="OUR SERVICES" fontWeight={700} color="#5E17EB" />
            </Grid>
          
            
            {/* Description section */}
            <Grid item container xs={11} md={10} style={{marginTop: "5px"}} justifyContent={"center"} alignItems={"center"}>
                <CustomLabelMediumRegular
                    normal={false}
                    text={<>
                    Struggling to find the right tech talent or scale efficiently? We don’t just offer Mobile App Development Services - we solve your biggest tech challenges. Whether you're launching, growing, or innovating, being the top rated 
                    &nbsp;<a href="https://ostryx.com" target="_blank" rel="noopener noreferrer" style={{color: "#5E17EB"}}><b>IOs </b></a>
                    and 
                    &nbsp;<a href="https://ostryx.com" target="_blank" rel="noopener noreferrer" style={{color: "#5E17EB"}}><b>Android App Development Company</b></a> 
                    &nbsp;we deliver smart expertise for real progress - without delays!
                    </>}
                />
            </Grid>

            {/* Service cards */}
            <Grid item container justifyContent="space-between"
                  sx={{padding: {xs: "0px 20px", md: "0px 40px"}, marginTop: {xs: "20px", md: "60px"}, alignItems: "stretch"}}>
                {serviceCards.map((card, index) => (
                    <ServiceCard key={card.title} card={card} index={index}/>
                ))}
            </Grid>

            {/* Learn More button */}
            {/* <Grid item>
                <Grid item container 
                onClick={() => navigate('/services')}
                sx={{
                    border: "1.5px solid #5E17EB",
                    borderRadius: "16px",
                    padding: {xs:"10px 15px",md:"15px 45px"},
                    background: "transparent",
                    marginTop: {xs: "20px", md: "60px"},
                    cursor: "pointer"
                }} alignItems="center" justifyContent="center">
                    <Grid item>
                        <CustomLabelSmallMedium text="Learn More" color="#5E17EB"/>
                    </Grid>
                    <Grid item sx={{ ml: 1 }}>
                        <NorthEastIcon sx={{ color: "#5E17EB" }}/>
                    </Grid>
                </Grid>
            </Grid> */}
        </Grid>
    );
};

export default OurServices;
